import { IntentFilterSelect } from '@ipfabric/ui-components/IntentFilterSelect/IntentFilterSelect';
import type { IntentFilterSelectOptions } from '@ipfabric/ui-components/IntentFilterSelect/IntentFilterSelect.types';
import type { ReportSeverityKey } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { useTableContextSelectors } from 'components/Table/model/TableModel';
import { useMemo } from 'react';
import type { FC } from 'react';
import type { ChangeIntentFilterEvent } from './types/ChangeFilterEvent';

interface Props {
  className?: string;
  onChangeIntentFilter: (command: ChangeIntentFilterEvent) => void;
  column: string;
}

export const IntentFilter: FC<Props> = (props) => {
  const ctxProps = useTableContextSelectors({
    reports: prop('reports'),
    intentFilters: prop('intentFilters'),
  });

  const handleChange = (value: ReportSeverityKey | null) => {
    props.onChangeIntentFilter({
      column: props.column,
      severity: value,
    });
  };

  const options = useMemo(() => {
    const columnReports = ctxProps.reports?.[props.column];

    if (!columnReports?.result?.checks) {
      return {};
    }
    return Object.entries(
      columnReports.result.checks,
    ).reduce<IntentFilterSelectOptions>((acc, [severity]) => {
      acc[severity as ReportSeverityKey] =
        columnReports.descriptions?.checks?.[severity as ReportSeverityKey];
      return acc;
    }, {});
  }, [ctxProps.reports, props.column]);

  if (Object.values(options).length === 0) {
    return null;
  }

  return (
    <IntentFilterSelect
      className={props.className}
      value={ctxProps.intentFilters?.[props.column] ?? null}
      onChange={handleChange}
      options={options}
    />
  );
};
